import {useState, useEffect, useRef, useContext} from 'react'
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import {connect} from 'react-redux'

import styled from 'styled-components'
import SVG from "react-inlinesvg";
import IconAvatar from "../img/icons/icon_avatar.svg"
import IconAvatarChecked from "../img/icons/icon_avatar_checked.svg"
import IconInfo from "../img/icons/icon_info.svg"
import IconTriangleDown from "../img/icons/icon_triangle_down.svg"
import LoginModal from "../components/LoginModal"
import Dropdown from "../components/Dropdown"
import {login, logout} from "../redux/actions/userActions"
import i18next from 'i18next';
import { getTabindex } from '../helper/tabindexHelper';

const LoginInfoButton = ({subscriptions, user, login, logout}) => {
    const [dropdownActive, setDropdownActive] = useState(false)
    const [loginModalActive, setLoginModalActive] = useState(false)
    const ref = useRef(null)
    const {t} = useTranslation()
    const themeContext = useContext(ThemeContext);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref && ref.current && !ref.current.contains(event.target)) {
                    // @ts-ignore
                    setDropdownActive(false)

                
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //Close login modal after successful login
    useEffect(() => {
        if(user.loggedIn){
            setLoginModalActive(false)
        }
    }, [user])

    const handleLogin = (username, password) => {
        login(themeContext.backend, themeContext.appName, username, password)
    }

    const renderInfoLink = (infoItem, index) => {
        //if there is a link in the current language, display that info
        if(infoItem[i18next.language]){
            return <DropdownLink key={index} target="blank" href={infoItem[i18next.language].link} tabIndex={getTabindex("infoLink")}>{infoItem[i18next.language].text}</DropdownLink>
        } else {
            return <DropdownLink key={index} target="blank" href={infoItem.link} tabIndex={getTabindex("infoLink")}>{infoItem.text}</DropdownLink>
        }
    }

    return(
        <>
        <Wrapper ref={ref} onClick={() => setDropdownActive(!dropdownActive)} aria-label={t('informations')}>
            <IconWrapper {...(dropdownActive && { active: dropdownActive })} tabIndex={getTabindex("infoLink")}>
                {
                    themeContext.login.type === "internal" ? 
                    (
                        user.loggedIn ?
                        <Icon src={IconAvatarChecked}/>
                        :
                        <Icon src={IconAvatar}/>

                    )
                    
                    :
                    <Icon src={IconInfo}/>
                }
                <IconTransform {...(dropdownActive && { active: dropdownActive })} src={IconTriangleDown}/>
            </IconWrapper>
            <Dropdown {...(dropdownActive && { active: dropdownActive })}>
                {
                    themeContext.login.type === "internal" && !user.loggedIn &&
                    <LoginButton onClick={() => setLoginModalActive(true)} tabIndex={getTabindex("infoLink")}>
                        <Icon src={IconAvatar}/>
                        <LoginButtonText>{t('login')}</LoginButtonText>
                    </LoginButton>
                }
                {
                    themeContext.login.type === "internal" && user.loggedIn &&
                    <LoginButton onClick={() => logout()} tabIndex={getTabindex("infoLink")}>
                        <Icon src={IconAvatarChecked}/>
                        <LogoutTextWrapper>
                            <LoginButtonText>{user.username}</LoginButtonText>
                            <LogoutButtonText>{t('logout')}</LogoutButtonText>
                        </LogoutTextWrapper>
                        
                    </LoginButton>
                }
                {
                    themeContext.info.length > 0 && themeContext.info.map((item, index) => (
                        renderInfoLink(item, index)
                    ))
                }
            </Dropdown>
            

        </Wrapper>
        <LoginModal {...(loginModalActive && { active: loginModalActive })} close={() => setLoginModalActive(false)} login={handleLogin} subscriptions={subscriptions} user={user}/>
        </>
    )
}

const mapStateToProps = (state, props) => {
    return {
      subscriptions: state.subscriptions,
      user: state.user
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    login: (backend, appName, username, password) => dispatch(login(backend, appName, username, password)),
    logout: () => dispatch(logout())
  })

export default connect(mapStateToProps, mapDispatchToProps)(LoginInfoButton)

type ButtonProps = {
    active: boolean
}

const Wrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
`

const IconWrapper = styled.button<ButtonProps>`
    display: flex;
    align-items: center;
    opacity: ${props => props.active ? 0.65 : 1};
    border: none;
    background: none;
    &:hover {
        opacity: 0.65;
    }
`

const Icon = styled(SVG)`
    &:last-of-type {
        margin-left: 9px;
    }

`
const IconTransform = styled(SVG)<ButtonProps>`
    transform: ${props => props.active && 'rotate(180deg)'};
    transition: all .5s ease-out;
    &:last-of-type {
        margin-left: 9px;
    }

`



const DropdownLink = styled.a`
    height: 36px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${props => props.theme.color.grey_700};
    &:hover {
        background-color: ${props => props.theme.color.grey_50};
    }
`

const LoginButton = styled.button`
    height: 66px;
    padding-left: 3px;
    align-items: center;
    display: flex;
    border: none;
    border-bottom: 1px solid ${props => props.theme.color.grey_100};
    background:none;
    padding: 0;
    cursor: pointer;
    &:hover {
        background-color: ${props => props.theme.color.grey_50};
    }
`

const LoginButtonText = styled.span`
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    color: ${props => props.theme.color.grey_900};
    margin: 0 12px;
`

const LogoutTextWrapper = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const LogoutButtonText = styled.span`
    margin-top: 6px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 100%;
    margin-left: 12px;
    color: ${props => props.theme.color.grey_600};
`